'use client';
import { useGetCategories } from '../get-categories';
import { Provider } from './types';

import { cache, useState } from 'react';
import useBackend from '@/backend';
import { useCasinoStoreActions, useProviders } from '@/store';

export interface ProviderList {
	id: string;
	name: { EN: string; ES: string; FR: string };
	iconUrl: string;
	orderId: number;
}

/* --------------------------------- OPTIONS -------------------------------- */
const headers: { 'Content-Type': string; Authorization?: string } = {
	'Content-Type': 'application/json',
};

const route = '/casino/get-providers';

/* -------------------------------------------------------------------------- */

export const useGetProviders = () => {
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState<string | null>(null);
	const { url } = useBackend();
	const { setProviders } = useCasinoStoreActions();

	/* -------------------------------------------------------------------------- */

	const getProviders = cache(async () => {
		try {
			setLoading(true);
			setError(null);
			const apiUrl = `${url}${route}`;

			const response = await fetch(apiUrl, {
				method: 'GET',
				headers,
			});

			const data = await response.json();

			if (!data?.data?.providers) {
				throw new Error('Failed to load');
			}

			const formattedData = data?.data?.providers as Provider[];

			setProviders(formattedData);

			/* -------------------------------------------------------------------------- */

			return formattedData;
			/* -------------------------------------------------------------------------- */
		} catch (e: unknown) {
			const message = e instanceof Error ? e.message : 'Unknown error';
			setError(message);
			if (e instanceof Error) return [];

			return [];
		} finally {
			setLoading(false);
		}
	});
	return {
		loading,
		error,
		getProviders,
	};
};
